import React from 'react';
import { cn } from '@crisellevaldez/speculo-ui';
import { formatDate, type DateInput } from '../../utils/dateTime';

interface TimestampLabelProps {
  value?: DateInput | null;
  /** IANA zone, normally the org's. Falls back to UTC, as formatDate does. */
  timezone?: string;
  /** Extra classes for layout; the type treatment is fixed so surfaces match. */
  className?: string;
}

/**
 * The one way a stored timestamp is shown to an agent: `MMM D, YYYY h:mm A z`
 * in the org's timezone, upper-cased and never wrapping. Activity rows, the
 * consent trail, and anything else showing "when this happened" render through
 * this so the treatment stays identical.
 */
export const TimestampLabel: React.FC<TimestampLabelProps> = ({ value, timezone, className }) => {
  if (!value) return null;

  return (
    <span
      className={cn(
        'whitespace-nowrap text-[10px] uppercase text-muted-foreground xl:text-xs',
        className
      )}
    >
      {formatDate(value, timezone)}
    </span>
  );
};
